import * as React from 'react'
export const GeAb = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#6DA544" d="M0 0h513v48.8H0zm0 97.5h513v48.8H0zM0 195h513v48.8H0zm0 97.6h513v48.8H0z" />
    <path fill="#D80027" d="M0 0h256.5v146.3H0z" />
    <path fill="#FFF" d="m116.9 114.4-7.5-14.8V69.9L128 59l18.6 10.9v22.3l7.4-7.4 4.2 3-4.2 11.8-14.9 14.8z" />
    <circle cx={82} cy={82.8} r={5.4} fill="#FFF" />
    <circle cx={90.8} cy={61.7} r={5.4} fill="#FFF" />
    <circle cx={106.6} cy={46.2} r={5.4} fill="#FFF" />
    <circle cx={128} cy={40.8} r={5.4} fill="#FFF" />
    <circle cx={149.4} cy={46.2} r={5.4} fill="#FFF" />
    <circle cx={165.2} cy={61.7} r={5.4} fill="#FFF" />
    <circle cx={174} cy={82.8} r={5.4} fill="#FFF" />
  </svg>
)
